var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 38,
    viewBox: "0 0 63 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 27V3C9 1.89543 9.89543 1 11 1H60C61.1046 1 62 1.89543 62 3V27C62 28.1046 61.1046 29 60 29H11C9.89543 29 9 28.1046 9 27Z",
    fill: "#E3F2FD",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 35V11C1 9.89543 1.89543 9 3 9H52C53.1046 9 54 9.89543 54 11V35C54 36.1046 53.1046 37 52 37H3C1.89543 37 1 36.1046 1 35Z",
    fill: "white",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6883 23.147C20.6883 27.3153 17.3105 30.694 13.1442 30.694C8.97784 30.694 5.6 27.3153 5.6 23.147C5.6 18.9787 8.97784 15.6 13.1442 15.6C17.3105 15.6 20.6883 18.9787 20.6883 23.147Z",
    fill: "#E3F2FD",
    stroke: "#2962FF",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8641 28.0618C17.4775 29.6733 15.4324 30.6957 13.1446 30.6957C10.8571 30.6957 8.81217 29.6735 7.42558 28.0624C8.55859 26.0652 10.6892 24.7172 13.1446 24.7172C15.6008 24.7172 17.7358 26.0658 18.8641 28.0618Z",
    fill: "white",
    stroke: "#2962FF",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1992 20.4928C15.1992 21.6279 14.2794 22.5477 13.1452 22.5477C12.011 22.5477 11.0912 21.6279 11.0912 20.4928C11.0912 19.3577 12.011 18.4379 13.1452 18.4379C14.2794 18.4379 15.1992 19.3577 15.1992 20.4928Z",
    fill: "white",
    stroke: "#2962FF",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.2V20.8C24 19.2536 25.2536 18 26.8 18H46.2C47.7464 18 49 19.2536 49 20.8V25.2C49 26.7464 47.7464 28 46.2 28H26.8C25.2536 28 24 26.7464 24 25.2Z",
    fill: "#E3F2FD",
    stroke: "#2962FF",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrIcon);
export default __webpack_public_path__ + "static/media/hrIcon.c833e5fa941b5a46cc9a16347d66e8f1.svg";
export { ForwardRef as ReactComponent };